import React from "react";
import '../header/header.css'
import img from '../../images/me.svg'
// import img2 from '../../images/centerpic.png'
import img2 from '../../images/icon.png'

function Header(){
    return(
        <div className="headerContainer">
            <h1 className="headerh1"> Designer, FullStack Developer & Freelancer</h1>
            <h4 className="headerh3">I design and code beautifully simple things, and I love what I do.</h4>
            <img className="headerImg" src={img} alt="me"/>
            <img className="headerImg2" src={img2} alt="me"/>
        </div>
    )
}
export default Header;